var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import SendForm from "../SendForm/SendForm";
import ChatList from "../ChatList/ChatList";
import styles from "./ChatContainer.module.scss";
import chatBotApi from "../../api/chatbot";
import { useDispatch, useSelector } from "react-redux";
import { sendMessage, getAllMessages, isResponseLoading, setIsResponseLoading, currentSessionId, isUserResponseLoading, setIsUserResponseLoading } from "../../stores/reducers/chatReducer";
import LoadingChatBotResponse from "../LoadingChatBotResponse/LoadingChatBotResponse";
import { forEach, isEmpty, values } from "lodash";
import { CONFIGURABLE_LOADING_INDICATOR_TYPE_TEXT, getSettings, getTranslation } from "../../constants/setting";
import { MESSAGE_TYPE_CATEGORY, MESSAGE_TYPE_CONTACT_FORM, MESSAGE_TYPE_NOT_FOUND_OPTIONS, MESSAGE_TYPE_WELCOME } from "../../constants";
import LoadingChatBotResponseText from "../LoadingChatBotResponseText/LoadingChatBotResponseText";
import { isLanguageRTL } from "../../../../constants";
var ChatContainer = function () {
    var dispatch = useDispatch();
    var _b = useState([]), errorMessages = _b[0], setErrorMessages = _b[1];
    var messages = useSelector(getAllMessages);
    var isLoading = useSelector(isResponseLoading);
    var isUserLoading = useSelector(isUserResponseLoading);
    var sessionId = useSelector(currentSessionId);
    var language = getSettings().language;
    var _j = getSettings(), welcome_message = _j.welcome_message, configurable_loading_indicator_type = _j.configurable_loading_indicator_type, configurable_loading_indicator_text = _j.configurable_loading_indicator_text, topics = _j.topics, current_page_url = _j.current_page_url, disable_question_button = _j.disable_question_button;
    var dispatchCategory = function () {
        setTimeout(function () {
            dispatch(setIsResponseLoading(false));
            dispatch(sendMessage({
                response: {
                    type: MESSAGE_TYPE_CATEGORY,
                    language: language,
                    data: {
                        showCategories: true
                    }
                }
            }));
        }, 1000);
    };
    var sendInquiry = function (text) {
        dispatch(sendMessage({ send: text }));
        dispatch(setIsUserResponseLoading(true));
        setErrorMessages([]);
        chatBotApi.postSendMessage(sessionId, text, current_page_url).then(function (response) {
            var _b, _j;
            forEach(response.data, function (value, key) {
                dispatch(sendMessage({
                    response: value
                }));
            });
            dispatch(setIsUserResponseLoading(false));
            dispatch(setIsResponseLoading(true));
            if (response.data[0].type !== MESSAGE_TYPE_NOT_FOUND_OPTIONS) {
                dispatchCategory();
            }
            else {
                if (response.data[0].type === MESSAGE_TYPE_NOT_FOUND_OPTIONS && ((_j = (_b = response.data[0]) === null || _b === void 0 ? void 0 : _b.data) === null || _j === void 0 ? void 0 : _j.items.length) < 1) {
                    getDistrictSearches(text);
                }
            }
        }).catch(function (error) {
            if (error.response && error.response.status === 400) {
                var messages_1 = error.response.data.error.messages;
                setErrorMessages(values(messages_1));
            }
            else {
                console.error(error);
                console.log(error);
            }
            dispatch(setIsUserResponseLoading(false));
        }).finally(function () {
            dispatch(setIsResponseLoading(false));
        });
    };
    var getDistrictSearches = function (text) {
        chatBotApi.searchDistrictSite({
            text: text,
            current_page_url: current_page_url
        }).then(function (response) {
            dispatch(sendMessage({ response: response.data }));
        }).catch(function (err) {
            console.error(err);
            console.log(err);
        }).finally(function () {
            dispatchCategory();
        });
    };
    var handleContactFormFromURL = function () {
        var url = new URLSearchParams(window.location.search);
        if (url.get('show_contact_form')) {
            dispatch(sendMessage({
                response: {
                    type: MESSAGE_TYPE_CONTACT_FORM,
                    language: language,
                    data: {
                        text: getTranslation('chatbot.send_contact_form') + ':',
                        show: true,
                        submitted: false,
                        language: language,
                        topics: topics
                    }
                }
            }));
        }
    };
    useEffect(function () {
        if (isEmpty(messages)) {
            dispatch(setIsResponseLoading(true));
            setTimeout(function () {
                if (welcome_message) {
                    dispatch(sendMessage({
                        response: {
                            type: MESSAGE_TYPE_WELCOME,
                            language: language,
                            data: {
                                text: getSettings().welcome_message
                            }
                        }
                    }));
                }
                dispatch(sendMessage({
                    response: {
                        type: MESSAGE_TYPE_CATEGORY,
                        language: language,
                        data: {
                            showCategories: true
                        }
                    }
                }));
                handleContactFormFromURL();
                dispatch(setIsResponseLoading(false));
            }, 1000);
        }
        else {
            handleContactFormFromURL();
        }
    }, []);
    return _jsxs("div", __assign({ className: styles.chatBox }, { children: [_jsx(ChatList, { conversation: messages }), isLoading && _jsx(LoadingChatBotResponse, {}), isUserLoading ? (configurable_loading_indicator_type === CONFIGURABLE_LOADING_INDICATOR_TYPE_TEXT && configurable_loading_indicator_text ?
                _jsx(LoadingChatBotResponseText, { message: configurable_loading_indicator_text }) : _jsx(LoadingChatBotResponse, {})) : null, !isEmpty(errorMessages) && _jsx("div", __assign({ className: "".concat(styles.sendMessageError, " ").concat(isLanguageRTL(language) && styles.rtl) }, { children: _jsx("ul", { children: errorMessages.map(function (value) { return _jsx("li", { children: _jsx("small", { children: value }) }); }) }) })), !disable_question_button ? _jsx(SendForm, { sendInquiry: sendInquiry }) : null] }));
};
export default ChatContainer;
